var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCigna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,22)",
    stroke: "#2f3742",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 10,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 8,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 20,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 3,
    y2: 17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 4,
    stroke: "#2f3742",
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 38,
    fontFamily: "Georgia, serif",
    fontSize: 32,
    fontWeight: 700,
    fontStyle: "italic",
    fill: "#2f3742",
    letterSpacing: -1
  }, "cigna")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 52,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#555"
  }, "healthcare")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCigna);
export default __webpack_public_path__ + "static/media/logo-cigna.58fd65169b59a91226dafbabe715c98c.svg";
export { ForwardRef as ReactComponent };